import { render } from "./SplashAdPurchaseView.vue?vue&type=template&id=6c7a61b8&scoped=true"
import script from "./SplashAdPurchaseView.vue?vue&type=script&lang=js"
export * from "./SplashAdPurchaseView.vue?vue&type=script&lang=js"

import "./SplashAdPurchaseView.vue?vue&type=style&index=0&id=6c7a61b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c7a61b8"]])

export default __exports__